(() => {
  if(window.__forgeMobileProductLoaded)return;
  window.__forgeMobileProductLoaded=true;
  const media=window.matchMedia('(max-width:749px)');
  const placements=new Map();
  const place=(node,anchor)=>{
    if(!node||!anchor||node===anchor||node.contains(anchor))return;
    if(!placements.has(node)){const mark=document.createComment('forge original placement');node.before(mark);placements.set(node,mark);}
    if(node.nextElementSibling!==anchor)anchor.before(node);
  };
  const placeAfter=(node,anchor)=>{
    if(!node||!anchor||node.contains(anchor))return;
    if(!placements.has(node)){const mark=document.createComment('forge original placement');node.before(mark);placements.set(node,mark);}
    if(anchor.nextElementSibling!==node)anchor.after(node);
  };
  const moveInto=(node,parent)=>{
    if(node.parentElement===parent)return;
    if(!placements.has(node)){const mark=document.createComment('forge original placement');node.before(mark);placements.set(node,mark);}
    parent.append(node);
  };
  const restore=()=>{
    for(const [node,mark]of placements){if(mark.isConnected&&node.isConnected&&mark.nextSibling!==node)mark.after(node);}
  };
  const visible=node=>!!node&&node.getClientRects().length>0&&getComputedStyle(node).visibility!=='hidden';
  const watchedChatRoots=new WeakSet();
  function chatClearance(roots){
    const html=document.documentElement;
    const host=document.querySelector('shopify-chat');
    const shell=host?.shadowRoot;
    const runtime=shell?.querySelector('shopify-agent-runtime')?.shadowRoot;
    for(const shadow of [shell,runtime]){
      if(shadow&&!watchedChatRoots.has(shadow)){
        watchedChatRoots.add(shadow);
        new MutationObserver(schedule).observe(shadow,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','class','aria-expanded','open']});
      }
    }
    const activator=runtime?.querySelector('[part="activator"]');
    const dialog=runtime?.querySelector('[part="dialog"]');
    let offset=0;
    const modalOpen=document.body.classList.contains('overflow-hidden')||document.querySelector('.cart-notification.active,details.menu-opening');
    if(media.matches&&roots.length&&visible(activator)&&!visible(dialog)&&!modalOpen){
      const previous=parseFloat(html.style.getPropertyValue('--ff-pdp-chat-clearance'))||0;
      const rect=activator.getBoundingClientRect();
      const base={left:rect.left,right:rect.right,top:rect.top+previous,bottom:rect.bottom+previous};
      const regions=roots.flatMap(root=>[...root.querySelectorAll('product-form button[name="add"],.shopify-payment-button,.quantity,variant-selects select,recipient-form input:not([type="hidden"]),recipient-form textarea,[class*="variantSelector_container"],[id^="rbr-bundle-"] :is(button,[role="button"]),.ff-pdp-sticky')])
        .filter(visible).map(node=>node.getBoundingClientRect()).filter(r=>r.height>0&&r.bottom>0&&r.top<innerHeight&&r.left<base.right&&r.right>base.left);
      for(let pass=0;pass<=regions.length;pass++){
        const collisions=regions.filter(r=>base.bottom-offset>r.top-12&&base.top-offset<r.bottom+12);
        if(!collisions.length)break;
        const next=Math.max(...collisions.map(r=>base.bottom-r.top+12));
        if(next<=offset)break;
        offset=next;
      }
      offset=Math.ceil(Math.max(0,Math.min(offset,base.top-8)));
    }
    const value=offset+'px';
    if(html.style.getPropertyValue('--ff-pdp-chat-clearance')!==value)html.style.setProperty('--ff-pdp-chat-clearance',value);
  }
  let frame;
  document.addEventListener('click',event=>{
      const button=event.target.closest?.('.ff-pdp-sticky-button');
      const root=button?.closest('product-info[data-forge-mobile="true"]');
      if(!root)return;
      const target=root.querySelector('product-form button[name="add"]');
      const choices=root.dataset.forgeRequiresChoices==='true';
      if(!target||!visible(target))return;
      if(choices){
        const picker=root.querySelector('variant-selects,recipient-form,[id^="rbr-bundle-"]')||target;
        picker.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
        const focus=picker.querySelector('input:not([type="hidden"]),select,button')||target;
        focus.focus({preventScroll:true});
      }else if(!target.disabled&&target.getAttribute('aria-disabled')!=='true'){
        target.click();
      }
    });
  function refresh(){
    const roots=[...document.querySelectorAll('product-info[data-forge-mobile="true"]')];
    document.documentElement.classList.toggle('ff-pdp-mobile',media.matches&&roots.length>0);
    if(!media.matches)restore();
    let anySticky=false;
    for(const root of roots){
      if(media.matches){
        document.documentElement.style.setProperty('--ff-pdp-header-logo',root.style.getPropertyValue('--ff-pdp-logo')||'84px');
        const info=root.querySelector('.product__info-container');
        const price=info?.querySelector('[id^="price-"]');
        const summary=info?.querySelector('.ff-pdp-summary');
        const badge=info?.querySelector('.ff-pdp-app:has(.jdgm-preview-badge)');
        if(summary&&price)place(summary,price);
        if(badge&&summary)place(badge,summary);else if(badge&&price)place(badge,price);
        const claims=[...info.querySelectorAll('.product__text')];
        if(claims.length){
          let group=info.querySelector('.ff-pdp-claims');
          if(!group){group=document.createElement('div');group.className='ff-pdp-claims';claims[0].before(group);}
          claims.forEach(node=>moveInto(node,group));
        }
        if(root.dataset.forgeReorderUpsells==='true'&&root.dataset.forgeRequiresChoices!=='true'){
          const details=info?.querySelector('.ff-pdp-details');
          // Keep Fast Bundle's React descendants inside their event-listening root.
          // Moving an individual bundle card disconnects its delegated clicks.
          const bundleRoots=new Set([...root.querySelectorAll('[id^="rbr-bundle-"]')]
            .map(node=>node.closest('[id^="rbr-container-element-"]'))
            .filter(node=>node&&root.contains(node)));
          bundleRoots.forEach(node=>{if(details)placeAfter(node,details);});
        }
      }
      const details=root.querySelector('.ff-pdp-details');
      if(details&&details.dataset.forgeInitialised!=='true'){
        details.dataset.forgeInitialised='true';
        details.open=!media.matches||root.dataset.forgeMobileDetails!=='true';
      }else if(details&&!media.matches)details.open=true;
      const sticky=root.querySelector('.ff-pdp-sticky');
      if(!sticky)continue;
      const native=root.querySelector('product-form button[name="add"]');
      const form=root.querySelector('product-form form');
      const price=root.querySelector('.product__info-container [id^="price-"] .price');
      const action=sticky.querySelector('button');
      const priceCopy=sticky.querySelector('.ff-pdp-sticky-price');
      if(price&&priceCopy&&priceCopy.innerHTML!==price.outerHTML)priceCopy.innerHTML=price.outerHTML;
      const disabled=!native||native.disabled||native.getAttribute('aria-disabled')==='true';
      const label=disabled?root.dataset.forgeSoldoutLabel:root.dataset.forgeRequiresChoices==='true'?root.dataset.forgeChooseLabel:root.dataset.forgeAddLabel;
      if(action.textContent!==label)action.textContent=label;
      action.disabled=disabled;
      const top=native?.getBoundingClientRect().bottom||0;
      const chatDialog=document.querySelector('shopify-chat')?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part="dialog"]');
      const modalOpen=document.body.classList.contains('overflow-hidden')||document.querySelector('.cart-notification.active,details.menu-opening,dialog[open],[role="dialog"][aria-modal="true"]:not([hidden]).is-visible')||visible(chatDialog);
      const shouldShow=media.matches&&visible(native)&&visible(form)&&visible(price)&&top<0&&!modalOpen;
      sticky.hidden=!shouldShow;
      anySticky=anySticky||shouldShow;
    }
    document.documentElement.classList.toggle('ff-pdp-sticky-visible',anySticky);
    chatClearance(roots);
  }
  const schedule=()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;refresh();});};
  document.addEventListener('DOMContentLoaded',schedule,{once:true});
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('product-info:loaded',schedule);
  document.addEventListener('change',schedule);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  media.addEventListener('change',schedule);
  const observer=new MutationObserver(records=>{
    if(records.every(r=>r.target.closest?.('.ff-pdp-sticky')))return;
    schedule();
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
  schedule();
})();
